import { render } from "./EditingMediaAudioSimple.vue?vue&type=template&id=356fff4e"
import script from "./EditingMediaAudioSimple.vue?vue&type=script&lang=js"
export * from "./EditingMediaAudioSimple.vue?vue&type=script&lang=js"
script.render = render

export default script